import { getFingerPrint } from "@/utils/fingerPrint"
import { fetchAPI } from "@/api/api"
import { unreadResponseSchema } from "@/schemas/shared"
import { z } from "zod/v4"
import { stringParam, jsonParam } from "@/schemas/requestParams"

const ACCOUNT_TRACKER_API_URL = "/exchange/member/playerService/accountTracker"

// accountTracker (AccountTrackerBO.java:421-453)
const accountTrackerRequestSchema = z.strictObject({
  fingerprint2: stringParam(32).optional(),
  // JSON object (fingerprint, fingerprintCanvas, fingerprintWebGL, audio, fonts, hardware,
  // locales, math, permissions, plugins, screen, system, thumbmarkjsVersion); read only
  // while ENABLE_THUMBMARK_JS is on
  thumbmark: jsonParam(z.record(z.string(), z.unknown())).optional()
})

const fetch = {
  url: ACCOUNT_TRACKER_API_URL,
  handler: async () => {
    const { state: webSiteState } = useWebsiteInfoStore()

    const thumbmark = await getFingerPrint()

    const res = await fetchAPI({
      data: {
        // fingerprint2 欄位改送 isApp 旗標供 ELK 辨識，不再計算 TrafficStatistics2 指紋
        fingerprint2: `isApp=${webSiteState.isApp}`,
        thumbmark: JSON.stringify(thumbmark)
      },
      url: ACCOUNT_TRACKER_API_URL,
      // 後端拒絕寫入時仍回 HTTP 200(3001 account is null／9999 例外)，需依 status 判斷失敗
      hasStatus: true,
      requestSchema: accountTrackerRequestSchema,
      schema: unreadResponseSchema
    })

    return res
  }
}

export default fetch
